import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { IntegrationKlasselotterietData } from './Data';

export type IntegrationKlasselotterietState = BaseIntegrationState;

export class IntegrationKlasselotterietModel extends BaseIntegration<
  IntegrationKlasselotterietData,
  IntegrationKlasselotterietState
> {
  authorSignature(): string {
    return 'Istvan Bovan';
  }

  hasVueComponent() {
    return false;
  }
}
